function shouldShowSplashScreen() {
    if(sessionStorage.getItem('hasVisited')) {
        sessionStorage.setItem('hasVisited', true);
        $('.siteHider').fadeOut(200);
    } else {
        showSplashScreen();
        sessionStorage.setItem('hasVisited', true);
    }
}

function showSplashScreen() {
    let body = document.querySelector('body');

    let splashScreen = document.createElement('div');
    splashScreen.setAttribute('class', 'splash-screen');

        let background = document.createElement('div');
        background.setAttribute('class', 'splash-background');

        let elementWrapper = document.createElement('div');
        elementWrapper.setAttribute('class', 'element-wrapper');

            let logo = document.createElement('div');
            logo.setAttribute('class', 'splash-logo');

            // Add all of the elements
            let solar = document.createElement('div');
            solar.setAttribute('class', 'solar element');
            let solarIcon = document.createElement('div');
            solarIcon.setAttribute('class', 'icon');
            let leftStroke = document.createElement('div');
            leftStroke.setAttribute('class', 'leftStroke strokes');
            solar.append(solarIcon, leftStroke);

            let water = document.createElement('div');
            water.setAttribute('class', 'water element');
            let waterIcon = document.createElement('div');
            waterIcon.setAttribute('class', 'icon');
            let bottomStroke = document.createElement('div');
            bottomStroke.setAttribute('class', 'bottomStroke strokes');
            water.append(waterIcon, bottomStroke);

            let energy = document.createElement('div');
            energy.setAttribute('class', 'energy element');
            let energyIcon = document.createElement('div');
            energyIcon.setAttribute('class', 'icon');
            let rightStroke = document.createElement('div');
            rightStroke.setAttribute('class', 'rightStroke strokes');
            energy.append(energyIcon, rightStroke);

            let wind = document.createElement('div');
            wind.setAttribute('class', 'wind element');
            let windIcon = document.createElement('div');
            windIcon.setAttribute('class', 'icon');
            let topStroke = document.createElement('div');
            topStroke.setAttribute('class', 'topStroke strokes');
            wind.append(windIcon, topStroke);

    elementWrapper.append(solar, wind, water, energy, logo);
    splashScreen.append(elementWrapper, background);
    body.append(splashScreen);

    animateSplashScreen();
}

function animateSplashScreen() {
    $('.splash-screen').css('background', 'rgba(240, 240, 240, 1)');
    $('.siteHider').hide();
    $('.splash-background').animate({opacity: 1}, 
                                    {duration: 500, ease: 'easeOut'});

    // Add splash screen expand icon boxes
    $('.element').animate({
        height: '140px',
        width: '140px',
    },{
        duration: 1000,
        ease: 'easeOut',
    });

    let animationTime = 350;

    // Add icons and line between the boxes
    setTimeout( function() {

        // Animate strokes
        $('.element.solar > .icon').animate({opacity: 1}, 
                                            {ease: 'ease', duration: 600});
        $('.leftStroke').animate({width: '40px', height: '5px'}, 
                                 {ease: 'ease', duration: animationTime});

        setTimeout( function() {
            $('.element.wind > .icon').animate({opacity: 1}, 
                                               {ease: 'ease', duration: 600});
            $('.topStroke').animate({width: '5px', height: '40px'}, 
                                    {ease: 'ease', duration: animationTime});
        }, animationTime)

        setTimeout( function() {
            $('.element.energy > .icon').animate({opacity: 1}, 
                                                 {ease: 'ease', duration: 600});
            $('.rightStroke').animate({width: '40px', height: '5px'}, 
                                      {ease: 'ease', duration: animationTime});
        }, animationTime * 2)

        setTimeout( function() {
            $('.element.water > .icon').animate({opacity: 1}, 
                                                {ease: 'ease', duration: 600});
            $('.bottomStroke').animate({width: '5px', height: '40px'}, 
                                       {ease: 'ease', duration: animationTime});
        }, animationTime * 3)

        setTimeout( function() {
            $('.splash-logo').css('opacity', 1);
        }, animationTime * 4);
    }, 1000);

    // Fade out splash screen
    setTimeout( function() {
        $('.splash-screen').animate({opacity: '0'}, 1250);
        $('.splash-screen').animate({backdropFilter: 'blur(0px)'}, 1250);
    }, animationTime * 6 + 1000);

    // Remove splash screen
    setTimeout( function() {
        $('.splash-screen').remove();
    }, animationTime * 6 + 5000);
}

window.addEventListener('load', function() {
    console.log('run splash screen');
    shouldShowSplashScreen();
});

